import { FilterIcon2 } from '@assets/icons';
import { InformationIcon } from '@assets/icons/index';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ConditionalComponent } from '@components/functionComponent';
import SkeletonComponent from '@components/skeleton';
import React from 'react';

export default function SummaryCard({
    Icon = InformationIcon,
    title = 'Title',
    value = 'Value',
    isFilter,
    isFiltered,
    isLoading = false,
    onClick = () => {},
}) {
    const customStyle = isFilter
        ? {
              border: '2px solid',
              borderColor: isFiltered ? 'sagitarius.500' : 'transparent',
              cursor: 'pointer',
              transition: 'border-color 0.2s',
              _hover: { borderColor: 'sagitarius.500' },
          }
        : {};

    return (
        <Box bg={'semantic.200'} p={'16px'} borderRadius={'4px'} {...customStyle} onClick={onClick}>
            <Flex alignItems="center" gap="8px" mb="8px">
                <Icon size={16} />
                <Text fontSize={'sm'}>{title}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} gap={'8px'} alignItems={'center'}>
                <ConditionalComponent
                    statement={!isLoading}
                    fallback={<SkeletonComponent height={'24px'} width={'75px'} />}
                >
                    <Text fontWeight={'bold'}>{value}</Text>
                </ConditionalComponent>
                {isFilter && !isFiltered && (
                    <Flex alignItems="center" gap="8px" color="neutral.500">
                        <FilterIcon2 />
                        <Text fontSize={'xs'} color={'sagitarius.500'} fontWeight={'bold'}>
                            Filter
                        </Text>
                    </Flex>
                )}
            </Flex>
        </Box>
    );
}
